import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["message", "options", "useGap"];
import { isValidElement, cloneElement, useContext } from 'react';
import I18n from 'I18n';
// @ts-expect-error untyped JS module
import { getPassThroughProps, interpolateToArray } from './utils';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_OPTIONS = {};
// @ts-expect-error untyped
const getEscapedParam = (param, key, index) => {
  if (! /*#__PURE__*/isValidElement(key)) {
    return /*#__PURE__*/_jsx("span", {
      // @ts-expect-error formatParam i is untyped
      dangerouslySetInnerHTML: {
        __html: I18n.formatParam(param, key)
      }
    }, `${param}-${index}`);
  }
  return /*#__PURE__*/cloneElement(key, {
    key: `${param}-${index}`,
    // @ts-expect-error Property 'ref' does not exist on type 'ReactElement<unknown, string | JSXElementConstructor<any>>
    ref: key.ref
  });
};
function FormattedReactMessage(_ref) {
  let {
      message,
      options = DEFAULT_OPTIONS,
      useGap = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  useContext(I18nHMRContext);
  const props = getPassThroughProps(Object.assign({
    message,
    options,
    useGap
  }, rest));
  const formattedMessage = interpolateToArray(message, options, getEscapedParam);
  return /*#__PURE__*/_jsx("span", Object.assign({}, props, {
    children: formattedMessage
  }));
}
FormattedReactMessage.displayName = 'FormattedReactMessage';
FormattedReactMessage.isI18nElement = true;
export default FormattedReactMessage;